import { type StateCreator } from 'zustand';

export type WorkspaceRightPanelWidthSlice = {
  width: number;
  setWidth: (width: number) => void;
};

export type CreateWorkspaceRightPanelWidthSlice = (options: {
  getInitialWidth: () => number;
  syncWidthToCSS: (width: number) => void;
}) => StateCreator<WorkspaceRightPanelWidthSlice, [], [], WorkspaceRightPanelWidthSlice>;

export const createWorkspaceRightPanelWidthSlice: CreateWorkspaceRightPanelWidthSlice =
  ({ getInitialWidth, syncWidthToCSS }) =>
  (set) => ({
    width: getInitialWidth(),
    setWidth: (width: number) => {
      syncWidthToCSS(width);
      set({ width });
    },
  });
